import InputQuestion from "./InputQuestion";
import { Tabs, Tab, ButtonGroup, ToggleButton, Alert } from "react-bootstrap";
import { ReactComponent as File } from "../assets/feathericons/file-text.svg";
import { ReactComponent as Star } from "../assets/feathericons/star.svg";
import { useState } from "react";

const BodyQuestionsResponses = ({
  addTextQst,
  addNoteQst,
  list,
  setList,
  data,
  handleSaveData,
}) => {
  // radio buttons
  const radios = [
    { name: "1", value: "1" },
    { name: "2", value: "2" },
    { name: "3", value: "3" },
    { name: "4", value: "4" },
    { name: "5", value: "5" },
  ];
  // showing alert
  const [show, setShow] = useState(false);

  // save the edit of question, show modal and it after 3 secondes
  const handleSaveAndShowModal = () => {
    handleSaveData();
    setShow(true);
    setTimeout(() => {
      setShow(false);
    }, 3000);
  };

  return (
    <div className="questions-responses">
      <Tabs defaultActiveKey="questions" className="tab-qst-res">
        {/**** QUESTIONS *****/}
        <Tab eventKey="questions" title="Questions">
          <div>
            {/* all the input got here */}
            {list.map((elem, index) => (
              <div className="input-question">
                <InputQuestion
                  addTextQst={addTextQst}
                  addNoteQst={addNoteQst}
                  list={list}
                  setList={setList}
                  key={index}
                  elem={elem}
                  index={index}
                />
              </div>
            ))}
          </div>
          {show && (
            <Alert
              variant="success"
              onClose={() => setShow(false)}
              dismissible
              style={{ padding: 17 }}
            >
              <p>Changements bien enregistrés</p>
            </Alert>
          )}

          {/* bottom buttons - add qst and save */}
          <div className="btn-addqst">
            <div>
              <button className="add-questions" onClick={addTextQst}>
                <File style={{ height: 15 }} />
                <p>Ajouter une question "Texte"</p>
              </button>
              <button className="add-questions" onClick={addNoteQst}>
                <Star style={{ height: 15 }} />
                <p>Ajouter une question "Note"</p>
              </button>
            </div>
            <a className="btn-answer" onClick={handleSaveAndShowModal}>
              <span>Sauvegarder</span>
            </a>
          </div>
        </Tab>

        {/***** RESPONSES *****/}

        <Tab eventKey="responses" title="Réponses">
          {list.map((elem, index) => (
            <>
              <div className="qst-res">
                <div className="question-line">
                  {list[index].type === "text" ? (
                    <div className="index-question">
                      <span>{index + 1} - </span>
                      <File style={{ height: 20 }} />
                    </div>
                  ) : (
                    <div className="index-question2">
                      <span>{index + 1} - </span>
                      <Star style={{ height: 16 }} />
                    </div>
                  )}
                  <div className="question-name" key={index}>
                    <p>{elem.name}</p>
                  </div>
                </div>
                {/* map the answers */}
                {data.answers.map((e, i) => (
                  <>
                    {/* compare the type of question */}
                    {list[index].type === "text" ? (
                      <p className="response-line" key={i}>
                        {e[index]}
                      </p>
                    ) : (
                      <p className="response-line" key={i}>
                        <ButtonGroup toggle defaultValue={e[index]}>
                          {radios.map((radio, idx) => (
                            // radio buttons
                            <ToggleButton
                              key={idx}
                              type="radio"
                              variant="secondary"
                              name="radio"
                              value={radio.value}
                              checked={radio.value === e[index]}
                            >
                              {radio.name}
                            </ToggleButton>
                          ))}
                        </ButtonGroup>
                      </p>
                    )}
                  </>
                ))}
              </div>
            </>
          ))}
        </Tab>
      </Tabs>
    </div>
  );
};

export default BodyQuestionsResponses;
